export function suggestDuplicateName(
  name: string,
  existing: { name: string }[]
): string {
  const taken = new Set(existing.map((t) => t.name.toLowerCase()))

  for (let attempt = 1; ; attempt++) {
    const suffix = attempt === 1 ? " – Copy" : ` – Copy ${attempt}`
    const candidate = `${name}${suffix}`
    if (!taken.has(candidate.toLowerCase())) return candidate
  }
}
